



import { defineComponent, ref, onMounted, onUnmounted } from '@vue/composition-api'
import { EventBus } from '@/models/event-bus'

export default defineComponent({
    setup() {
        const showOverlay = ref(false)

        onMounted(() => {
            EventBus.$on('closeOverlay', () => {
                showOverlay.value = false
            })
            EventBus.$on('openOverlay', () => {
                showOverlay.value = true
            })
        })

        onUnmounted(() => {
            EventBus.$off('closeOverlay')
            EventBus.$off('openOverlay')
        })

        return {
            showOverlay
        }
    }
})
